<!-- =========================================================================================
  File Name: CouponView.vue
  Description: Coupon options display for selection
  ----------------------------------------------------------------------------------------
  Item Name: deltaPOS - Coupon view
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->


<template>
  <!--    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">-->
  <vs-popup fullscreen :active.sync="isSpecialActiveLocal" :title="title">
    <form-wizard
      ref="couponWizard"
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      :hide-buttons="true">
      <tab-content v-for="(option, index) in data.comboOptions" :key="option.id" :title="option.description" icon="feather icon-package" class="mb-5">
        <template>
          <div class="flex justify-between mb-2">
            <div class="vx-col w-4/5">
              <h6>Mínimo {{ option.min }} - Máximo {{ option.max }} / <b>Seleccionados: {{ option.qtySelected }}</b></h6><br/>
            </div>
            <vs-spacer/>
            <div class="vx-col w-1/5">
              <vs-button
                class="ml-auto flex"
                icon-pack="feather" icon="icon-arrow-right-circle"
                color="success"
                v-if="option.qtySelected >= option.min && option.qtySelected <= option.max"
                @click.prevent="$refs.couponWizard.nextTab()">
                SIGUIENTE
              </vs-button>
            </div>
          </div>
          <div class="items-grid-view vx-row match-height">
            <div class="vx-col lg:w-1/5 sm:w-1/5 w-full" v-for="item in option.options" :key="item.id">
              <item-grid-view :item="item">
                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">
                  <div class="flex flex-wrap">
                    <vs-chip color="danger" style="position: absolute; top: 10px; left: 10px;" v-if="getQuantityCoupon(item)"><b>{{ item.qtySelected }}</b></vs-chip>
                    <!--                  <vs-avatar color="danger" icon-pack="feather" size="50px" style="position: absolute; top: 5px;" @text="item.qtySelected"/>-->
                  </div>
                  <div class="flex flex-wrap">

                    <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
                    <div class="item-view-primary-action-btn bg-success p-3 flex flex-grow items-center justify-center text-white cursor-pointer" @click="addQty(item, index)">
                      <feather-icon icon="ShoppingPlusCircle" svgClasses="h-4 w-4"/>

                      <span class="text-sm font-semibold ml-2">AGREGAR</span>
                    </div>

                    <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                    <div class="item-view-secondary-action-btn bg-danger p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                         @click="subtractQty(item, index)">
                      <feather-icon icon="ShoppingMinusCircle" svgClasses="h-4 w-4"/>

                      <span class="text-sm font-semibold ml-2">ELIMINAR</span>
                    </div>
                  </div>
                </template>
              </item-grid-view>

            </div>
          </div>
        </template>

      </tab-content>
      <tab-content title="Revisión" icon="feather icon-check-square">
        <template>
          <div class="vx-row">
            <div class="vx-col w-full">
              <h4>Productos seleccionados</h4><br/>
              <vs-list>
                <span  v-for="option in data.comboOptions" :key="option.id">
                  <vs-list-header icon-pack="feather" icon="icon-plus-square" :title="option.description"/>
                  <span v-for="item in option.options" :key="item.id">
                    <vs-list-item icon-pack="feather" icon="icon-check" :title="optionTitle(item)" v-if="item.qtySelected > 0"/>
                  </span>
                </span>
              </vs-list>
              <!--              <ul>-->
              <!--                <li v-for="option in data.comboOptions" :key="option.id">-->
              <!--                  <h6>{{ option.description }}</h6>-->
              <!--                  <ul>-->
              <!--                    <li v-for="item in option.options" :key="item.id">-->
              <!--                      <span v-if="item.qtySelected > 0">{{ item.qtySelected }} {{ item.description }}</span>-->
              <!--                    </li>-->
              <!--                  </ul>-->
              <!--                  <br>-->
              <!--                </li>-->
              <!--              </ul>-->
            </div>
          </div>
          <div class="flex justify-start">
            <vs-button
              icon-pack="feather" icon="icon-arrow-left-circle"
              color="danger"
              class="mr-2"
              @click="$refs.couponWizard.reset()"
            >
              CAMBIAR
            </vs-button>
            &nbsp;&nbsp;
            <vs-button
              icon-pack="feather" icon="icon-arrow-right-circle"
              color="success"
              @click="acceptCoupon"
            >
              ACEPTAR
            </vs-button>
          </div>
        </template>

      </tab-content>
    </form-wizard>
  </vs-popup>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  const ItemGridView = () => import('./ItemGridView.vue');

  export default {
    props: {
      id: {
        code: '',
        name: '',
        specialOptions: 0,
        specialData: [],
        comboOptions: [],
        selectedOptions: []
      },
      isSpecialActive: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        data: {
          code: '',
          name: '',
          specialOptions: 0,
          comboOptions: []
        },
        // comboOptions: [],
        acceptMobilePayment: false,
        selectedState: null,
        selectedCity: null,
        loaded: false,
        disableEditID: false,
        title: '',
        name: '',
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    components: {
      VuePerfectScrollbar,
      FormWizard,
      TabContent,
      ItemGridView
    },
    computed: {
      isSpecialActiveLocal: {
        get() {
          return this.isSpecialActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar');
          }
        }
      }
    },
    watch: {
      isSpecialActiveLocal: function () {
        if (this.isSpecialActiveLocal) {
          this.initValues();
          this.title = this.id.name;
          this.data = this.id;
          for (var i = 0; i < this.data.comboOptions.length; i++) {
            this.data.comboOptions[i].qtySelected = 0;
            this.data.comboOptions[i].title = this.data.comboOptions[i].description + ' - Mínimo ' + parseInt(this.data.comboOptions[i].min) + ' - Máximo ' + parseInt(this.data.comboOptions[i].max)
            for (var j = 0; j < this.data.comboOptions[i].options.length; j++) {
              this.data.comboOptions[i].options[j].qtySelected = 0;
            }
          }
        }
      }
    },
    methods: {
      initValues() {
        this.data = {
          code: '',
          name: '',
          specialOptions: 0,
          comboOptions: []
        };
        this.$refs.couponWizard.reset();
      },
      getQuantityCoupon(item) {
        var hasQuantity = false;
        if (item.hasOwnProperty('qtySelected')) {
          if (item.qtySelected > 0) {
            hasQuantity = true;
          }
        }
        return hasQuantity;
      },
      addQty(item, index) {
        if (this.data.comboOptions[index].qtySelected < this.data.comboOptions[index].max) {
          item.qtySelected++;
          this.data.comboOptions[index].qtySelected++;
          this.$forceUpdate();
        }
      },
      subtractQty(item, index) {
        if (item.qtySelected > 0) {
          item.qtySelected--;
          this.data.comboOptions[index].qtySelected--;
          this.$forceUpdate();
        }
      },
      optionTitle(option) {
        return `${option.qtySelected} ${option.description}`
      },
      acceptCoupon() {
        this.id.selectedOptions = [];
        var products;
        for (var i = 0; i < this.data.comboOptions.length; i++) {
          products = [];
          for (var j = 0; j < this.data.comboOptions[i].options.length; j++) {
            if (this.data.comboOptions[i].options[j].qtySelected > 0) {
              products.push(this.data.comboOptions[i].options[j]);
            }
          }
          this.id.selectedOptions.push({
            name: this.data.comboOptions[i].description,
            products: products
          });
        }
        this.isSpecialActiveLocal = false;
        this.$emit('addCouponCart');
      }

    }
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background {
      z-index: 52010;
    }

    /deep/ .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
